import { Pipe, PipeTransform } from "@angular/core";
import { ValidationErrors } from "@angular/forms";
import { TranslocoService } from "@jsverse/transloco";

@Pipe({
  name: "formError",
  standalone: true,
  pure: false,
})
//TODO use this pipe instead of formErrorsUtil in all forms
export class FormErrorPipe implements PipeTransform {
  constructor(private readonly translocoService: TranslocoService) {}

  transform(errors: ValidationErrors | undefined | null): string {
    let errorMessage = "";
    if (errors) {
      Object.entries(errors).forEach(([errorKey, errorValue]) => {
        switch (errorKey) {
          case "required":
            errorMessage = this.translate("mandatory");
            break;
          case "email":
            errorMessage = this.translate("email");
            break;
          case "minlength":
            errorMessage = this.translate("minlength").replace(
              "%d",
              errorValue["requiredLength"]
            );
            break;
          case "maxlength":
            errorMessage = this.translate("maxlength").replace(
              "%d",
              errorValue["requiredLength"]
            );
            break;
          case "pattern":
            errorMessage = this.translate("pattern");
            break;
          case "blank":
            errorMessage = this.translate("blank");
            break;
          case "invalidUrl":
            errorMessage = this.translate("invalidUrl");
            break;
          case "invalidGeoLocation":
            errorMessage = this.translate("invalidGeoLocation");
            break;
          default:
            errorMessage = this.translate("unknown").replace("%s", errorKey);
        }
      });
    }
    return errorMessage;
  }

  private translate(key: string): string {
    return this.translocoService.translate(`shared.validations.${key}`);
  }
}
